//-----------------------------------------------------------------------------
// Michael B. Gale's Website
// Copyright (c) 2022 Michael B. Gale (github@michael-gale.co.uk)
//-----------------------------------------------------------------------------

import * as React from "react";
import Linked from "./Linked";

//-----------------------------------------------------------------------------

interface FooterLinkProps {
    text: string;
    url: string;
}

const FooterLink = (props: FooterLinkProps) => {
    return <span>
        <Linked me url={props.url}>{props.text}</Linked>
    </span>;
}

const Footer = () => {
    return <footer>
        <span className="copyright">
            Copyright &copy; {new Date().getFullYear()} Michael B. Gale
        </span>
        <span className="links">
            <FooterLink text="GitHub" url="https://github.com/mbg" />
            <FooterLink text="LinkedIn" url="https://www.linkedin.com/in/michaelbgale/" />
            <FooterLink text="Scholar" url="https://scholar.google.com/citations?user=VI0IBuIAAAAJ&hl=en" />
            <FooterLink text="Mastodon" url="https://mastodon.social/@mbg" />
        </span>
    </footer>;
}

export default Footer;

//-----------------------------------------------------------------------------
